module.exports = __webpack_public_path__ + "static/07-d65fd9fa5efc0efe5bd7bea545155116.jpg";